import './App.svelte.css';
/* src/App.svelte generated by Svelte v3.44.2 */
import {
	SvelteComponent,
	add_flush_callback,
	append,
	assign,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	get_spread_object,
	get_spread_update,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_store_value,
	set_style,
	space,
	src_url_equal,
	svg_element,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import GroupPlayback from "./add-ons/GroupPlayback.svelte.js";
import LibraryView from "./layouts/LibraryView.svelte.js";
import AlbumView from "./layouts/AlbumView.svelte.js";
import ArtistView from "./layouts/ArtistView.svelte.js";
import Search from "./layouts/Search.svelte.js";
import Lyrics from "./add-ons/Lyrics.svelte.js";
import Modal from "./components/Modal.svelte.js";
import IconButton from "./components/IconButton.svelte.js";
import Glow from "./components/Glow.svelte.js";
import { liveQuery } from "../_snowpack/pkg/dexie.js";
import ServerManager from "./layouts/ServerManager.svelte.js";
import { db, library, servers } from "./logic/db.js";
import { authString, arrayShuffle } from "./logic/utils.js";

import {
	playing,
	queue,
	queueIndex,
	playState,
	browserHistory,
	browserHistoryIndex,
	currentPanel,
	browse
} from "./logic/stores.js";

import Song from "./components/Song.svelte.js";
import SongList from "./components/SongList.svelte.js";
import { onMount } from "../_snowpack/pkg/svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[11] = list[i];
	child_ctx[31] = i;
	return child_ctx;
}

// (101:4) {:else}
function create_else_block(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = "album.svg")) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "class", "albumCover svelte-7egau3");
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (91:4) {#if $playing?.coverUrl}
function create_if_block_5(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*$playing*/ ctx[7].server + /*$playing*/ ctx[7].coverUrl + "?auth=" + authString(/*$servers*/ ctx[8], /*$playing*/ ctx[7]))) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "loading", "lazy");
			attr(img, "class", "albumCover svelte-7egau3");
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*$playing, $servers*/ 384 && !src_url_equal(img.src, img_src_value = /*$playing*/ ctx[7].server + /*$playing*/ ctx[7].coverUrl + "?auth=" + authString(/*$servers*/ ctx[8], /*$playing*/ ctx[7]))) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (90:3) <Glow noMobile>
function create_default_slot_3(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*$playing*/ ctx[7]?.coverUrl) return create_if_block_5;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, [-1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (142:3) {#if $queue.length > 0}
function create_if_block_4(ctx) {
	let div;
	let iconbutton0;
	let t;
	let iconbutton1;
	let current;

	iconbutton0 = new IconButton({
			props: {
				icon: "shuffle",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	iconbutton0.$on("click", /*click_handler_2*/ ctx[19]);

	iconbutton1 = new IconButton({
			props: {
				icon: "list",
				accent: /*showingAll*/ ctx[9],
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	iconbutton1.$on("click", /*click_handler_3*/ ctx[20]);

	return {
		c() {
			div = element("div");
			create_component(iconbutton0.$$.fragment);
			t = space();
			create_component(iconbutton1.$$.fragment);
			attr(div, "class", "horizPanel");
			set_style(div, "margin-block", "calc(var(--pad) * 1.5)");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(iconbutton0, div, null);
			append(div, t);
			mount_component(iconbutton1, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const iconbutton0_changes = {};

			if (dirty[1] & /*$$scope*/ 2) {
				iconbutton0_changes.$$scope = { dirty, ctx };
			}

			iconbutton0.$set(iconbutton0_changes);
			const iconbutton1_changes = {};
			if (dirty[0] & /*showingAll*/ 512) iconbutton1_changes.accent = /*showingAll*/ ctx[9];

			if (dirty[1] & /*$$scope*/ 2) {
				iconbutton1_changes.$$scope = { dirty, ctx };
			}

			iconbutton1.$set(iconbutton1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(iconbutton0.$$.fragment, local);
			transition_in(iconbutton1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(iconbutton0.$$.fragment, local);
			transition_out(iconbutton1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(iconbutton0);
			destroy_component(iconbutton1);
		}
	};
}

// (145:5) <IconButton        icon="shuffle"        on:click={_ => {         let currentSong = $queue.splice($queueIndex, 1)[0];         $queue = [currentSong, ...arrayShuffle($queue)];         $queueIndex = 0;        }}>
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("Shuffle");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (154:5) <IconButton        icon="list"        accent={showingAll}        on:click={_ => {         showingAll = !showingAll;        }}>
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Show All");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (197:41) 
function create_if_block_3(ctx) {
	let search;
	let current;
	const search_spread_levels = [/*browsing*/ ctx[11].props];
	let search_props = {};

	for (let i = 0; i < search_spread_levels.length; i += 1) {
		search_props = assign(search_props, search_spread_levels[i]);
	}

	search = new Search({ props: search_props });

	return {
		c() {
			create_component(search.$$.fragment);
		},
		m(target, anchor) {
			mount_component(search, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const search_changes = (dirty[0] & /*$browserHistory*/ 16)
			? get_spread_update(search_spread_levels, [get_spread_object(/*browsing*/ ctx[11].props)])
			: {};

			search.$set(search_changes);
		},
		i(local) {
			if (current) return;
			transition_in(search.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(search.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(search, detaching);
		}
	};
}

// (195:41) 
function create_if_block_2(ctx) {
	let artistview;
	let current;
	const artistview_spread_levels = [/*browsing*/ ctx[11].props];
	let artistview_props = {};

	for (let i = 0; i < artistview_spread_levels.length; i += 1) {
		artistview_props = assign(artistview_props, artistview_spread_levels[i]);
	}

	artistview = new ArtistView({ props: artistview_props });

	return {
		c() {
			create_component(artistview.$$.fragment);
		},
		m(target, anchor) {
			mount_component(artistview, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const artistview_changes = (dirty[0] & /*$browserHistory*/ 16)
			? get_spread_update(artistview_spread_levels, [get_spread_object(/*browsing*/ ctx[11].props)])
			: {};

			artistview.$set(artistview_changes);
		},
		i(local) {
			if (current) return;
			transition_in(artistview.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(artistview.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(artistview, detaching);
		}
	};
}

// (193:40) 
function create_if_block_1(ctx) {
	let albumview;
	let current;
	const albumview_spread_levels = [/*browsing*/ ctx[11].props];
	let albumview_props = {};

	for (let i = 0; i < albumview_spread_levels.length; i += 1) {
		albumview_props = assign(albumview_props, albumview_spread_levels[i]);
	}

	albumview = new AlbumView({ props: albumview_props });

	return {
		c() {
			create_component(albumview.$$.fragment);
		},
		m(target, anchor) {
			mount_component(albumview, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const albumview_changes = (dirty[0] & /*$browserHistory*/ 16)
			? get_spread_update(albumview_spread_levels, [get_spread_object(/*browsing*/ ctx[11].props)])
			: {};

			albumview.$set(albumview_changes);
		},
		i(local) {
			if (current) return;
			transition_in(albumview.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(albumview.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(albumview, detaching);
		}
	};
}

// (191:5) {#if browsing.view == "home"}
function create_if_block(ctx) {
	let libraryview;
	let current;
	const libraryview_spread_levels = [/*browsing*/ ctx[11].props];
	let libraryview_props = {};

	for (let i = 0; i < libraryview_spread_levels.length; i += 1) {
		libraryview_props = assign(libraryview_props, libraryview_spread_levels[i]);
	}

	libraryview = new LibraryView({ props: libraryview_props });

	return {
		c() {
			create_component(libraryview.$$.fragment);
		},
		m(target, anchor) {
			mount_component(libraryview, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const libraryview_changes = (dirty[0] & /*$browserHistory*/ 16)
			? get_spread_update(libraryview_spread_levels, [get_spread_object(/*browsing*/ ctx[11].props)])
			: {};

			libraryview.$set(libraryview_changes);
		},
		i(local) {
			if (current) return;
			transition_in(libraryview.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(libraryview.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(libraryview, detaching);
		}
	};
}

// (189:3) {#each $browserHistory as browsing, i}
function create_each_block(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let t;
	let current;
	const if_block_creators = [create_if_block, create_if_block_1, create_if_block_2, create_if_block_3];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*browsing*/ ctx[11].view == "home") return 0;
		if (/*browsing*/ ctx[11].view == "album") return 1;
		if (/*browsing*/ ctx[11].view == "artist") return 2;
		if (/*browsing*/ ctx[11].view == "search") return 3;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_1(ctx, [-1, -1]))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			attr(div, "class", "browserPanel svelte-7egau3");
			toggle_class(div, "hidden", /*i*/ ctx[31] != /*$browserHistoryIndex*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(div, null);
			}

			append(div, t);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(div, t);
				} else {
					if_block = null;
				}
			}

			if (dirty[0] & /*$browserHistoryIndex*/ 8) {
				toggle_class(div, "hidden", /*i*/ ctx[31] != /*$browserHistoryIndex*/ ctx[3]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d();
			}
		}
	};
}

// (208:1) <Modal id="serverManager" bind:open={openModal}>
function create_default_slot(ctx) {
	let h1;
	let t1;
	let servermanager;
	let current;
	servermanager = new ServerManager({});

	return {
		c() {
			h1 = element("h1");
			h1.textContent = "Let's get connected.";
			t1 = space();
			create_component(servermanager.$$.fragment);
			attr(h1, "class", "svelte-7egau3");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			insert(target, t1, anchor);
			mount_component(servermanager, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(servermanager.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(servermanager.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			destroy_component(servermanager, detaching);
		}
	};
}

function create_fragment(ctx) {
	let main;
	let div4;
	let div1;
	let svg0;
	let g0;
	let path0;
	let path1;
	let t0;
	let div0;
	let iconbutton0;
	let t1;
	let iconbutton1;
	let t2;
	let div3;
	let glow;
	let t3;
	let div2;
	let h1;
	let t4_value = (/*$playing*/ ctx[7]?.title || "--") + "";
	let t4;
	let t5;
	let p;
	let t6_value = (/*$playing*/ ctx[7]?.artist || "--") + "";
	let t6;
	let t7;
	let t8_value = (/*$playing*/ ctx[7]?.album || "--") + "";
	let t8;
	let t9;
	let t10_value = (/*$playing*/ ctx[7]?.year || "--") + "";
	let t10;
	let t11;
	let audio;
	let audio_src_value;
	let t12;
	let h20;
	let t14;
	let t15;
	let songlist;
	let t16;
	let div7;
	let div5;
	let iconbutton2;
	let t17;
	let iconbutton3;
	let t18;
	let iconbutton4;
	let t19;
	let h21;
	let t20_value = /*browsing*/ ctx[11].title + "";
	let t20;
	let t21;
	let div6;
	let t22;
	let div8;
	let groupplayback;
	let t23;
	let lyrics;
	let t24;
	let modal;
	let updating_open;
	let t25;
	let div9;
	let svg1;
	let g1;
	let path2;
	let path3;
	let t26;
	let iconbutton5;
	let t27;
	let iconbutton6;
	let t28;
	let iconbutton7;
	let t29;
	let iconbutton8;
	let t30;
	let iconbutton9;
	let current;
	let mounted;
	let dispose;
	iconbutton0 = new IconButton({ props: { icon: "storage" } });
	iconbutton0.$on("click", /*click_handler*/ ctx[13]);
	iconbutton1 = new IconButton({ props: { icon: "search" } });
	iconbutton1.$on("click", /*click_handler_1*/ ctx[14]);

	glow = new Glow({
			props: {
				noMobile: true,
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	let if_block = /*$queue*/ ctx[6].length > 0 && create_if_block_4(ctx);

	songlist = new SongList({
			props: {
				list: /*$queue*/ ctx[6],
				startOffset: /*showingAll*/ ctx[9] ? 0 : /*$queueIndex*/ ctx[5]
			}
		});

	iconbutton2 = new IconButton({ props: { icon: "arrow_back" } });
	iconbutton2.$on("click", /*click_handler_4*/ ctx[21]);
	iconbutton3 = new IconButton({ props: { icon: "arrow_forward" } });
	iconbutton3.$on("click", /*click_handler_5*/ ctx[22]);
	iconbutton4 = new IconButton({ props: { icon: "home" } });
	iconbutton4.$on("click", /*click_handler_6*/ ctx[23]);
	let each_value = /*$browserHistory*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	groupplayback = new GroupPlayback({});
	lyrics = new Lyrics({});

	function modal_open_binding(value) {
		/*modal_open_binding*/ ctx[24](value);
	}

	let modal_props = {
		id: "serverManager",
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	if (/*openModal*/ ctx[0] !== void 0) {
		modal_props.open = /*openModal*/ ctx[0];
	}

	modal = new Modal({ props: modal_props });
	binding_callbacks.push(() => bind(modal, 'open', modal_open_binding));

	iconbutton5 = new IconButton({
			props: {
				icon: "play_arrow",
				accent: /*$currentPanel*/ ctx[10] == "player"
			}
		});

	iconbutton5.$on("click", /*click_handler_7*/ ctx[25]);

	iconbutton6 = new IconButton({
			props: {
				icon: "library_music",
				accent: /*$currentPanel*/ ctx[10] == "browser"
			}
		});

	iconbutton6.$on("click", /*click_handler_8*/ ctx[26]);

	iconbutton7 = new IconButton({
			props: {
				icon: "add",
				accent: /*$currentPanel*/ ctx[10] == "add-ons"
			}
		});

	iconbutton7.$on("click", /*click_handler_9*/ ctx[27]);
	iconbutton8 = new IconButton({ props: { icon: "storage" } });
	iconbutton8.$on("click", /*click_handler_10*/ ctx[28]);
	iconbutton9 = new IconButton({ props: { icon: "search" } });
	iconbutton9.$on("click", /*click_handler_11*/ ctx[29]);

	return {
		c() {
			main = element("main");
			div4 = element("div");
			div1 = element("div");
			svg0 = svg_element("svg");
			g0 = svg_element("g");
			path0 = svg_element("path");
			path1 = svg_element("path");
			t0 = space();
			div0 = element("div");
			create_component(iconbutton0.$$.fragment);
			t1 = space();
			create_component(iconbutton1.$$.fragment);
			t2 = space();
			div3 = element("div");
			create_component(glow.$$.fragment);
			t3 = space();
			div2 = element("div");
			h1 = element("h1");
			t4 = text(t4_value);
			t5 = space();
			p = element("p");
			t6 = text(t6_value);
			t7 = text(" • ");
			t8 = text(t8_value);
			t9 = text(" • ");
			t10 = text(t10_value);
			t11 = space();
			audio = element("audio");
			t12 = space();
			h20 = element("h2");
			h20.textContent = "Queue";
			t14 = space();
			if (if_block) if_block.c();
			t15 = space();
			create_component(songlist.$$.fragment);
			t16 = space();
			div7 = element("div");
			div5 = element("div");
			create_component(iconbutton2.$$.fragment);
			t17 = space();
			create_component(iconbutton3.$$.fragment);
			t18 = space();
			create_component(iconbutton4.$$.fragment);
			t19 = space();
			h21 = element("h2");
			t20 = text(t20_value);
			t21 = space();
			div6 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t22 = space();
			div8 = element("div");
			create_component(groupplayback.$$.fragment);
			t23 = space();
			create_component(lyrics.$$.fragment);
			t24 = space();
			create_component(modal.$$.fragment);
			t25 = space();
			div9 = element("div");
			svg1 = svg_element("svg");
			g1 = svg_element("g");
			path2 = svg_element("path");
			path3 = svg_element("path");
			t26 = space();
			create_component(iconbutton5.$$.fragment);
			t27 = space();
			create_component(iconbutton6.$$.fragment);
			t28 = space();
			create_component(iconbutton7.$$.fragment);
			t29 = space();
			create_component(iconbutton8.$$.fragment);
			t30 = space();
			create_component(iconbutton9.$$.fragment);
			attr(path0, "d", "M9.2642 31.9574C9.2848 28.353 11.3857 26.2109 14.5781 26.2109C17.7706 26.2109 19.6655 28.3118 19.6449 31.8132V50H29.7166V29.8359C29.7372 22.7095 25.3913 17.9517 18.7386 17.9517C14.0632 17.9517 10.5206 20.3203 9.12003 24.1719H8.76989V18.3636H-0.807528V50H9.2642V31.9574ZM44.8706 50.5355C49.2782 50.5355 52.3265 48.826 54.0566 45.5923H54.3038V50H63.7782V28.4972C63.7782 21.8033 57.8258 17.9517 49.7726 17.9517C41.2662 17.9517 36.4466 22.2358 35.6433 28.0028L44.9324 28.3324C45.3649 26.3139 47.0332 25.0781 49.6902 25.0781C52.1618 25.0781 53.7271 26.2727 53.7271 28.3942V28.4972C53.7271 30.4332 51.6262 30.8452 46.2299 31.3189C39.8244 31.8544 34.4693 34.223 34.4693 41.2259C34.4693 47.4872 38.8152 50.5355 44.8706 50.5355ZM47.9806 43.9446C45.6532 43.9446 44.0055 42.8324 44.0055 40.7315C44.0055 38.6925 45.612 37.4567 48.475 37.0241C50.3493 36.7564 52.6561 36.3445 53.7889 35.7472V38.7543C53.7889 41.8438 51.1937 43.9446 47.9806 43.9446ZM80.0083 31.9574C80.0289 28.353 82.1298 26.2109 85.3223 26.2109C88.5147 26.2109 90.4096 28.3118 90.389 31.8132V50H100.461V29.8359C100.481 22.7095 96.1355 17.9517 89.4828 17.9517C84.8074 17.9517 81.2647 20.3203 79.8642 24.1719H79.514V18.3636H69.9366V50H80.0083V31.9574ZM121.464 50.5973C131.412 50.5973 137.447 44.027 137.447 34.2848C137.447 24.522 131.412 17.9517 121.464 17.9517C111.516 17.9517 105.481 24.522 105.481 34.2848C105.481 44.027 111.516 50.5973 121.464 50.5973ZM121.526 42.9972C117.798 42.9972 115.738 39.4545 115.738 34.223C115.738 28.9709 117.798 25.4077 121.526 25.4077C125.13 25.4077 127.19 28.9709 127.19 34.223C127.19 39.4545 125.13 42.9972 121.526 42.9972ZM160.464 18.3636H154.759V10.7841H144.687V18.3636H140.506V25.7784H144.687V41.1641C144.625 47.5696 148.786 50.7827 155.891 50.4531C158.322 50.3295 160.072 49.8352 161.04 49.5469L159.516 42.2763C159.084 42.3793 158.075 42.5852 157.312 42.5852C155.685 42.5852 154.759 41.9261 154.759 40.0518V25.7784H160.464V18.3636ZM180.051 50.5973C188.352 50.5973 193.81 46.581 194.963 40.3608L185.715 40.093C184.933 42.1939 182.873 43.3267 180.237 43.3267C176.364 43.3267 173.975 40.7521 173.975 36.88V36.6122H195.066V34.0994C195.066 23.6776 188.722 17.9517 179.742 17.9517C170.185 17.9517 164.048 24.5014 164.048 34.3054C164.048 44.4389 170.103 50.5973 180.051 50.5973ZM173.975 30.7628C174.119 27.6115 176.612 25.2223 179.948 25.2223C183.264 25.2223 185.653 27.5291 185.695 30.7628H173.975Z");
			set_style(path0, "fill", "var(--text)");
			attr(path1, "d", "M257 30.5L205.25 60.3779L205.25 0.622124L257 30.5Z");
			set_style(path1, "fill", "var(--text)");
			attr(g0, "clip-path", "url(#clip0_8_2)");
			attr(svg0, "class", "logo");
			attr(svg0, "viewBox", "0 0 257 61");
			attr(svg0, "fill", "none");
			set_style(svg0, "height", "calc(var(--input-height) * 0.75)");
			attr(svg0, "xmlns", "http://www.w3.org/2000/svg");
			attr(div0, "class", "horizPanel");
			attr(div1, "class", "header svelte-7egau3");
			attr(div2, "class", "vertiPanel");
			set_style(div2, "margin-block", "calc(var(--pad) * 1.5)");
			set_style(div2, "gap", "calc(var(--pad) * 1)");
			if (!src_url_equal(audio.src, audio_src_value = /*$playing*/ ctx[7]?.server + /*$playing*/ ctx[7]?.mediaUrl + "?auth=" + authString(/*$servers*/ ctx[8], /*$playing*/ ctx[7]))) attr(audio, "src", audio_src_value);
			audio.controls = true;
			audio.autoplay = true;
			set_style(audio, "width", "100%");
			attr(div3, "class", "player svelte-7egau3");
			attr(div4, "class", "left svelte-7egau3");
			toggle_class(div4, "panelOpen", /*$currentPanel*/ ctx[10] == "player");
			attr(h21, "class", "svelte-7egau3");
			attr(div5, "class", "horizPanel browserControls svelte-7egau3");
			attr(div6, "class", "browserPanels svelte-7egau3");
			attr(div7, "class", "browser svelte-7egau3");
			toggle_class(div7, "panelOpen", /*$currentPanel*/ ctx[10] == "browser");
			attr(div8, "class", "add-ons svelte-7egau3");
			toggle_class(div8, "panelOpen", /*$currentPanel*/ ctx[10] == "add-ons");
			attr(path2, "d", "M10.2642 27.9574V46H0.192472V14.3636H9.76989V20.1719H10.12C10.8203 18.2358 12.0149 16.7185 13.7038 15.62C15.3928 14.5078 17.4044 13.9517 19.7386 13.9517C21.9631 13.9517 23.8923 14.4529 25.5263 15.4553C27.174 16.4439 28.451 17.8307 29.3572 19.6158C30.2772 21.3871 30.7304 23.4605 30.7166 25.8359V46H20.6449V27.8132C20.6586 26.0556 20.2124 24.6825 19.3061 23.6939C18.4136 22.7053 17.1709 22.2109 15.5781 22.2109C14.5208 22.2109 13.5871 22.4444 12.777 22.9112C11.9806 23.3643 11.3627 24.0166 10.9233 24.8679C10.4976 25.7192 10.2779 26.7491 10.2642 27.9574Z");
			attr(path3, "d", "M92 30.5L40.25 60.3779L40.25 0.622124L92 30.5Z");
			attr(svg1, "viewBox", "0 0 92 60");
			attr(svg1, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg1, "class", "smallLogo svelte-7egau3");
			attr(div9, "class", "mobileMenu horizPanel svelte-7egau3");
			attr(main, "class", "svelte-7egau3");
		},
		m(target, anchor) {
			insert(target, main, anchor);
			append(main, div4);
			append(div4, div1);
			append(div1, svg0);
			append(svg0, g0);
			append(g0, path0);
			append(g0, path1);
			append(div1, t0);
			append(div1, div0);
			mount_component(iconbutton0, div0, null);
			append(div0, t1);
			mount_component(iconbutton1, div0, null);
			append(div4, t2);
			append(div4, div3);
			mount_component(glow, div3, null);
			append(div3, t3);
			append(div3, div2);
			append(div2, h1);
			append(h1, t4);
			append(div2, t5);
			append(div2, p);
			append(p, t6);
			append(p, t7);
			append(p, t8);
			append(p, t9);
			append(p, t10);
			append(div3, t11);
			append(div3, audio);
			/*audio_binding*/ ctx[15](audio);
			append(div3, t12);
			append(div3, h20);
			append(div3, t14);
			if (if_block) if_block.m(div3, null);
			append(div3, t15);
			mount_component(songlist, div3, null);
			append(main, t16);
			append(main, div7);
			append(div7, div5);
			mount_component(iconbutton2, div5, null);
			append(div5, t17);
			mount_component(iconbutton3, div5, null);
			append(div5, t18);
			mount_component(iconbutton4, div5, null);
			append(div5, t19);
			append(div5, h21);
			append(h21, t20);
			append(div7, t21);
			append(div7, div6);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div6, null);
			}

			append(main, t22);
			append(main, div8);
			mount_component(groupplayback, div8, null);
			append(div8, t23);
			mount_component(lyrics, div8, null);
			append(main, t24);
			mount_component(modal, main, null);
			append(main, t25);
			append(main, div9);
			append(div9, svg1);
			append(svg1, g1);
			append(g1, path2);
			append(g1, path3);
			append(div9, t26);
			mount_component(iconbutton5, div9, null);
			append(div9, t27);
			mount_component(iconbutton6, div9, null);
			append(div9, t28);
			mount_component(iconbutton7, div9, null);
			append(div9, t29);
			mount_component(iconbutton8, div9, null);
			append(div9, t30);
			mount_component(iconbutton9, div9, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(audio, "ended", /*ended_handler*/ ctx[16]),
					listen(audio, "pause", /*pause_handler*/ ctx[17]),
					listen(audio, "play", /*play_handler*/ ctx[18])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			const glow_changes = {};

			if (dirty[0] & /*$playing, $servers*/ 384 | dirty[1] & /*$$scope*/ 2) {
				glow_changes.$$scope = { dirty, ctx };
			}

			glow.$set(glow_changes);
			if ((!current || dirty[0] & /*$playing*/ 128) && t4_value !== (t4_value = (/*$playing*/ ctx[7]?.title || "--") + "")) set_data(t4, t4_value);
			if ((!current || dirty[0] & /*$playing*/ 128) && t6_value !== (t6_value = (/*$playing*/ ctx[7]?.artist || "--") + "")) set_data(t6, t6_value);
			if ((!current || dirty[0] & /*$playing*/ 128) && t8_value !== (t8_value = (/*$playing*/ ctx[7]?.album || "--") + "")) set_data(t8, t8_value);
			if ((!current || dirty[0] & /*$playing*/ 128) && t10_value !== (t10_value = (/*$playing*/ ctx[7]?.year || "--") + "")) set_data(t10, t10_value);

			if (!current || dirty[0] & /*$playing, $servers*/ 384 && !src_url_equal(audio.src, audio_src_value = /*$playing*/ ctx[7]?.server + /*$playing*/ ctx[7]?.mediaUrl + "?auth=" + authString(/*$servers*/ ctx[8], /*$playing*/ ctx[7]))) {
				attr(audio, "src", audio_src_value);
			}

			if (/*$queue*/ ctx[6].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty[0] & /*$queue*/ 64) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_4(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div3, t15);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const songlist_changes = {};
			if (dirty[0] & /*$queue*/ 64) songlist_changes.list = /*$queue*/ ctx[6];
			if (dirty[0] & /*showingAll, $queueIndex*/ 544) songlist_changes.startOffset = /*showingAll*/ ctx[9] ? 0 : /*$queueIndex*/ ctx[5];
			songlist.$set(songlist_changes);

			if (dirty[0] & /*$currentPanel*/ 1024) {
				toggle_class(div4, "panelOpen", /*$currentPanel*/ ctx[10] == "player");
			}

			if ((!current || dirty[0] & /*browsing*/ 2048) && t20_value !== (t20_value = /*browsing*/ ctx[11].title + "")) set_data(t20, t20_value);

			if (dirty[0] & /*$browserHistoryIndex, $browserHistory*/ 24) {
				each_value = /*$browserHistory*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div6, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (dirty[0] & /*$currentPanel*/ 1024) {
				toggle_class(div7, "panelOpen", /*$currentPanel*/ ctx[10] == "browser");
			}

			if (dirty[0] & /*$currentPanel*/ 1024) {
				toggle_class(div8, "panelOpen", /*$currentPanel*/ ctx[10] == "add-ons");
			}

			const modal_changes = {};

			if (dirty[1] & /*$$scope*/ 2) {
				modal_changes.$$scope = { dirty, ctx };
			}

			if (!updating_open && dirty[0] & /*openModal*/ 1) {
				updating_open = true;
				modal_changes.open = /*openModal*/ ctx[0];
				add_flush_callback(() => updating_open = false);
			}

			modal.$set(modal_changes);
			const iconbutton5_changes = {};
			if (dirty[0] & /*$currentPanel*/ 1024) iconbutton5_changes.accent = /*$currentPanel*/ ctx[10] == "player";
			iconbutton5.$set(iconbutton5_changes);
			const iconbutton6_changes = {};
			if (dirty[0] & /*$currentPanel*/ 1024) iconbutton6_changes.accent = /*$currentPanel*/ ctx[10] == "browser";
			iconbutton6.$set(iconbutton6_changes);
			const iconbutton7_changes = {};
			if (dirty[0] & /*$currentPanel*/ 1024) iconbutton7_changes.accent = /*$currentPanel*/ ctx[10] == "add-ons";
			iconbutton7.$set(iconbutton7_changes);
		},
		i(local) {
			if (current) return;
			transition_in(iconbutton0.$$.fragment, local);
			transition_in(iconbutton1.$$.fragment, local);
			transition_in(glow.$$.fragment, local);
			transition_in(if_block);
			transition_in(songlist.$$.fragment, local);
			transition_in(iconbutton2.$$.fragment, local);
			transition_in(iconbutton3.$$.fragment, local);
			transition_in(iconbutton4.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(groupplayback.$$.fragment, local);
			transition_in(lyrics.$$.fragment, local);
			transition_in(modal.$$.fragment, local);
			transition_in(iconbutton5.$$.fragment, local);
			transition_in(iconbutton6.$$.fragment, local);
			transition_in(iconbutton7.$$.fragment, local);
			transition_in(iconbutton8.$$.fragment, local);
			transition_in(iconbutton9.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(iconbutton0.$$.fragment, local);
			transition_out(iconbutton1.$$.fragment, local);
			transition_out(glow.$$.fragment, local);
			transition_out(if_block);
			transition_out(songlist.$$.fragment, local);
			transition_out(iconbutton2.$$.fragment, local);
			transition_out(iconbutton3.$$.fragment, local);
			transition_out(iconbutton4.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(groupplayback.$$.fragment, local);
			transition_out(lyrics.$$.fragment, local);
			transition_out(modal.$$.fragment, local);
			transition_out(iconbutton5.$$.fragment, local);
			transition_out(iconbutton6.$$.fragment, local);
			transition_out(iconbutton7.$$.fragment, local);
			transition_out(iconbutton8.$$.fragment, local);
			transition_out(iconbutton9.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(main);
			destroy_component(iconbutton0);
			destroy_component(iconbutton1);
			destroy_component(glow);
			/*audio_binding*/ ctx[15](null);
			if (if_block) if_block.d();
			destroy_component(songlist);
			destroy_component(iconbutton2);
			destroy_component(iconbutton3);
			destroy_component(iconbutton4);
			destroy_each(each_blocks, detaching);
			destroy_component(groupplayback);
			destroy_component(lyrics);
			destroy_component(modal);
			destroy_component(iconbutton5);
			destroy_component(iconbutton6);
			destroy_component(iconbutton7);
			destroy_component(iconbutton8);
			destroy_component(iconbutton9);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $playState;
	let $browserHistoryIndex;
	let $browserHistory;
	let $queueIndex;
	let $queue;
	let $playing;
	let $library;
	let $servers;
	let $currentPanel;
	component_subscribe($$self, playState, $$value => $$invalidate(2, $playState = $$value));
	component_subscribe($$self, browserHistoryIndex, $$value => $$invalidate(3, $browserHistoryIndex = $$value));
	component_subscribe($$self, browserHistory, $$value => $$invalidate(4, $browserHistory = $$value));
	component_subscribe($$self, queueIndex, $$value => $$invalidate(5, $queueIndex = $$value));
	component_subscribe($$self, queue, $$value => $$invalidate(6, $queue = $$value));
	component_subscribe($$self, playing, $$value => $$invalidate(7, $playing = $$value));
	component_subscribe($$self, library, $$value => $$invalidate(12, $library = $$value));
	component_subscribe($$self, servers, $$value => $$invalidate(8, $servers = $$value));
	component_subscribe($$self, currentPanel, $$value => $$invalidate(10, $currentPanel = $$value));
	let openModal = "";
	window.db = db;

	onMount(async () => {
		let serversCount = (await db.servers.toArray()).length;

		if (serversCount == 0) {
			$$invalidate(0, openModal = "serverManager");
		}
	});

	let browsing = {};
	let audioElem;
	let showingAll = false;
	const click_handler = _ => $$invalidate(0, openModal = "serverManager");
	const click_handler_1 = _ => browse("search", "Search");

	function audio_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			audioElem = $$value;
			($$invalidate(1, audioElem), $$invalidate(2, $playState));
		});
	}

	const ended_handler = _ => {
		console.log("going to next");
		set_store_value(queueIndex, $queueIndex++, $queueIndex);
	};

	const pause_handler = e => {
		console.log(e);
		set_store_value(playState, $playState = { ...$playState, playing: false }, $playState);
	};

	const play_handler = e => {
		set_store_value(
			playState,
			$playState = {
				...$playState,
				playing: true,
				zeroTs: Date.now() / 1000 - e.target.currentTime
			},
			$playState
		);
	};

	const click_handler_2 = _ => {
		let currentSong = $queue.splice($queueIndex, 1)[0];
		set_store_value(queue, $queue = [currentSong, ...arrayShuffle($queue)], $queue);
		set_store_value(queueIndex, $queueIndex = 0, $queueIndex);
	};

	const click_handler_3 = _ => {
		$$invalidate(9, showingAll = !showingAll);
	};

	const click_handler_4 = _ => {
		if ($browserHistoryIndex > 0) {
			set_store_value(browserHistoryIndex, $browserHistoryIndex--, $browserHistoryIndex);
		}
	};

	const click_handler_5 = _ => {
		if ($browserHistoryIndex < $browserHistory.length - 1) set_store_value(browserHistoryIndex, $browserHistoryIndex++, $browserHistoryIndex);
	};

	const click_handler_6 = _ => browse("home", "Library");

	function modal_open_binding(value) {
		openModal = value;
		$$invalidate(0, openModal);
	}

	const click_handler_7 = _ => set_store_value(currentPanel, $currentPanel = "player", $currentPanel);
	const click_handler_8 = _ => set_store_value(currentPanel, $currentPanel = "browser", $currentPanel);
	const click_handler_9 = _ => set_store_value(currentPanel, $currentPanel = "add-ons", $currentPanel);
	const click_handler_10 = _ => $$invalidate(0, openModal = "serverManager");
	const click_handler_11 = _ => browse("search", "Search");

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*openModal*/ 1) {
			$: console.log(openModal);
		}

		if ($$self.$$.dirty[0] & /*$servers*/ 256) {
			$: console.log("Servers: ", $servers);
		}

		if ($$self.$$.dirty[0] & /*$library*/ 4096) {
			$: console.log("Library: ", $library);
		}

		if ($$self.$$.dirty[0] & /*$queue, $queueIndex*/ 96) {
			$: set_store_value(playing, $playing = $queue[$queueIndex], $playing);
		}

		if ($$self.$$.dirty[0] & /*$playing*/ 128) {
			$: console.log("Playing: ", $playing);
		}

		if ($$self.$$.dirty[0] & /*$playState*/ 4) {
			$: console.log("PlayState: ", $playState, Date.now() - $playState.zeroTs);
		}

		if ($$self.$$.dirty[0] & /*$browserHistory, $browserHistoryIndex*/ 24) {
			$: $$invalidate(11, browsing = $browserHistory[$browserHistoryIndex]);
		}

		if ($$self.$$.dirty[0] & /*$browserHistoryIndex*/ 8) {
			$: console.log("browserHistoryIndex: ", $browserHistoryIndex);
		}

		if ($$self.$$.dirty[0] & /*audioElem, $playState*/ 6) {
			$: {
				if (audioElem) {
					if ($playState.playing) {
						audioElem.play();
						$$invalidate(1, audioElem.currentTime = Date.now() / 1000 - $playState.zeroTs, audioElem);
					} else {
						audioElem.pause();
					}
				}
			}
		}
	};

	return [
		openModal,
		audioElem,
		$playState,
		$browserHistoryIndex,
		$browserHistory,
		$queueIndex,
		$queue,
		$playing,
		$servers,
		showingAll,
		$currentPanel,
		browsing,
		$library,
		click_handler,
		click_handler_1,
		audio_binding,
		ended_handler,
		pause_handler,
		play_handler,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		click_handler_6,
		modal_open_binding,
		click_handler_7,
		click_handler_8,
		click_handler_9,
		click_handler_10,
		click_handler_11
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {}, null, [-1, -1]);
	}
}

export default App;